import { fromJS, List, Record } from 'immutable';
import PropertyValue from './PropertyValue';

export interface ImmutablePropertyValue
  extends Omit<
    PropertyValue,
    'versions' | 'source' | 'sourceId' | 'timestamp' | 'updatedByUserId'
  > {
  source: null | string;
  sourceId: null | string;
  timestamp: null | number;
  updatedByUserId: null | number;
  versions?: List<Omit<ImmutablePropertyValue, 'versions'>>;
}

type PropertyValueRecordFactory = Record.Factory<ImmutablePropertyValue> & {
  fromJS(json?: any): PropertyValueRecordFactory | typeof json;
};

const PropertyValueRecord: PropertyValueRecordFactory = Object.assign(
  Record<ImmutablePropertyValue>(
    {
      name: undefined,
      source: null,
      sourceId: null,
      timestamp: null,
      updatedByUserId: null,
      value: undefined,
      versions: List(),
    },
    'PropertyValueRecord'
  ),
  {
    fromJS(json?: any): typeof PropertyValueRecord | typeof json {
      if (!json || typeof json !== 'object') {
        return json;
      }
      return PropertyValueRecord(fromJS(json));
    },
  }
);

export default PropertyValueRecord;
